<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-line-chart";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M3.75 15L4.6875 15.1312L13.2562 6.5625C13.0843 5.93288 13.0841 5.26871 13.2555 4.63896C13.427 4.00921 13.7639 3.43683 14.2313 2.98125C15.6938 1.5 18.0562 1.5 19.5187 2.98125C20.5125 3.95625 20.8313 5.34375 20.4938 6.5625L25.3125 11.3812L26.25 11.25C26.5875 11.25 26.9062 11.25 27.1875 11.3812L33.8812 4.6875C33.75 4.40625 33.75 4.0875 33.75 3.75C33.75 2.75544 34.1451 1.80161 34.8484 1.09835C35.5516 0.395088 36.5054 0 37.5 0C38.4946 0 39.4484 0.395088 40.1516 1.09835C40.8549 1.80161 41.25 2.75544 41.25 3.75C41.25 4.74456 40.8549 5.69839 40.1516 6.40165C39.4484 7.10491 38.4946 7.5 37.5 7.5C37.1625 7.5 36.8438 7.5 36.5625 7.36875L29.8688 14.0625C30 14.3438 30 14.6625 30 15C30 15.9946 29.6049 16.9484 28.9016 17.6516C28.1984 18.3549 27.2446 18.75 26.25 18.75C25.2554 18.75 24.3016 18.3549 23.5984 17.6516C22.8951 16.9484 22.5 15.9946 22.5 15L22.6312 14.0625L17.8125 9.24375C17.2125 9.375 16.5375 9.375 15.9375 9.24375L7.36875 17.8125L7.5 18.75C7.5 19.7446 7.10491 20.6984 6.40165 21.4016C5.69839 22.1049 4.74456 22.5 3.75 22.5C2.75544 22.5 1.80161 22.1049 1.09835 21.4016C0.395088 20.6984 0 19.7446 0 18.75C0 17.7554 0.395088 16.8016 1.09835 16.0984C1.80161 15.3951 2.75544 15 3.75 15Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
